import { gsap } from "gsap";

const heroRotator = () => {

    const hero = document.querySelector('.c-hero');
    if(!hero) return;

    const rotatorWrap = hero.querySelector('.c-rotator div');
    const originalValue = rotatorWrap.innerHTML;
    const otherValues = hero.querySelectorAll('.c-hero__services-list a');
    let values = [];
    otherValues.forEach(value => {
        values.push(value.outerHTML);
    });
    values.push(originalValue);

    const tl = gsap.timeline({
        repeat: -1,
        delay: 1
    });

    values.forEach(value => {
        tl
        .to(rotatorWrap, {
            autoAlpha: 0,
            y: 15,
            delay: 1,
            duration: 1.25,
            ease: 'power4.in'
        })
        .set(rotatorWrap, {
            innerHTML: value,
            y: -15
        })
        .to(rotatorWrap, {
            autoAlpha: 1,
            y: 0,
            duration: 2,
            ease: 'power4.out'
        });
    });

}

export { heroRotator }